export const PATH_GUIDES = '/guide';
export const PATH_GUIDES_OXY_SNACKS = '/guide/oxy-snacks';
